import { useEffect, type FC, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useUrlWithSearchParams } from "../../helpers/routeHelpers";
import { useProviderNetwork } from "../../helpers/context-hooks/useProviderNetwork";
import { useLoggedIn } from "../../helpers/loginHelpers";
import { useMctFlags } from "../../helpers/flag-hooks/useMctFlags";

export const ProviderNetworkRoute: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const isLoggedIn = useLoggedIn();
  const { tmpFeEnableProviderNetwork } = useMctFlags();
  const { enableProviderNetwork: anonEnableProviderNetwork } =
    useProviderNetwork();
  const enableProviderNetwork = isLoggedIn
    ? tmpFeEnableProviderNetwork
    : anonEnableProviderNetwork;

  const redirectUrl = useUrlWithSearchParams("/");
  const navigate = useNavigate();

  useEffect(() => {
    // Perform the redirect safely after rendering completes
    // Does not reliably work using the <Navigate /> component outside of an effect
    if (!enableProviderNetwork) {
      // Provider Network not enabled, go to landing page.
      navigate(redirectUrl, { replace: true });
    }
  }, [enableProviderNetwork, redirectUrl, navigate]);

  // Prevent rendering the children or anything else while redirecting
  if (!enableProviderNetwork) {
    return null;
  }

  return <>{children}</>;
};
